__turbopack_context__.v({
  "container": "OrderSummaryCosts-module__nHfa_q__container",
  "currentPrice": "OrderSummaryCosts-module__nHfa_q__currentPrice",
  "discountBanner": "OrderSummaryCosts-module__nHfa_q__discountBanner",
  "discountBannerWrapper": "OrderSummaryCosts-module__nHfa_q__discountBannerWrapper",
  "discountThisWeek": "OrderSummaryCosts-module__nHfa_q__discountThisWeek",
  "fullPrice": "OrderSummaryCosts-module__nHfa_q__fullPrice",
  "mainSummary": "OrderSummaryCosts-module__nHfa_q__mainSummary",
});
